import { useEffect, useRef } from "react";

/**
 * Returns `followPointer(onMove)`: from a pointerdown, calls `onMove` on every
 * pointer move until the pointer is released. Listens on the window so a fast
 * drag that outruns its handle keeps going; a panel closed mid-drag removes
 * its listeners on unmount.
 */
export const usePointerDrag = () => {
  const stopRef = useRef<(() => void) | null>(null);
  useEffect(() => () => stopRef.current?.(), []);

  return (onMove: (e: PointerEvent) => void) => {
    stopRef.current?.();
    const stop = () => {
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("pointerup", stop);
      window.removeEventListener("pointercancel", stop);
      stopRef.current = null;
    };
    stopRef.current = stop;
    window.addEventListener("pointermove", onMove);
    window.addEventListener("pointerup", stop);
    window.addEventListener("pointercancel", stop);
  };
};
